/* eslint-disable @next/next/no-img-element */
import {Button, Modal, ButtonProps} from 'antd';
import useCommon from '@utils/hooks/common';
import styles from './styles';
import classNames from 'classnames';
import {Sheet} from 'react-modal-sheet';

export interface CustomModalSheetProps {
  // className?: string;
  children?: React.ReactNode;
  isModalSheetOpen: boolean;
  onModalSheetClose: () => void;
  onModalSheetBack?: () => void;
  disableScrollLocking?: boolean;
  snapPoints?: number[];
  disableDrag?: boolean;
  title?: JSX.Element | string;
  sheetDetent?: 'full-height' | 'content-height';
  closable?: boolean;
}

const CustomModalSheet = (props: CustomModalSheetProps) => {
  const {classes, t} = useCommon({
    withTranslation: null,
    withStyles: styles,
  });

  const {
    children,
    isModalSheetOpen,
    onModalSheetClose,
    onModalSheetBack,
    sheetDetent = 'full-height',
    title,
    closable = true,
    ...rest
  } = props;

  return (
    <Sheet
      isOpen={isModalSheetOpen}
      onClose={onModalSheetClose}
      style={{zIndex: 2}}
      detent={sheetDetent}
      disableDrag
      {...rest}
    >
      <Sheet.Container
        className={classes.sheetContainer}
        style={{background: '#222835', borderRadius: '15px 15px 0 0'}}
      >
        <Sheet.Header className={classes.sheetHeader}>
          {onModalSheetBack && (
            <Button className={classes.backIcon} type="text" onClick={onModalSheetBack}>
              <img width={30} height={30} src="/icon/auth/arrowForward.svg" />
            </Button>
          )}
          <h3>{title}</h3>
          {closable && (
            <Button className={classes.closeIcon} type="text" onClick={onModalSheetClose}>
              <img width={30} height={30} src="/icon/close-icon.svg" />
            </Button>
          )}
        </Sheet.Header>
        <Sheet.Content className={classes.sheetContent}>
          <Sheet.Scroller style={{height: '100%'}}>{children} </Sheet.Scroller>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop
        style={{background: 'rgba(0, 0, 0, 0.5)', backdropFilter: 'blur(2px)'}}
        onTap={closable && onModalSheetClose}
      />
    </Sheet>
  );
};

export default CustomModalSheet;
